export default function ProfileIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 13.1958V15.9998L4.491 17.7888C3.297 18.2158 2.5 19.3468 2.5 20.6138V22.4998M21.5 22.4998V20.6138C21.5 19.3468 20.703 18.2158 19.509 17.7888L14.5 15.9998V13.1958"></path>
            <path d="M12 14C14.7614 14 17 11.3137 17 8C17 4.68629 14.7614 2 12 2C9.23858 2 7 4.68629 7 8C7 11.3137 9.23858 14 12 14Z"></path>
            <path d="M16.953 7.45283C16.785 7.47383 16.669 7.46682 16.5 7.49982C14.797 7.82783 13.703 7.21083 12.766 5.56982C12.203 6.64782 10.444 7.49982 8.99997 7.49982C8.28896 7.49982 7.67696 7.35382 7.06396 7.03382"></path>
        </svg>
    )
}